<template>
  <div>
    <v-toolbar v-if="deleteDialog != true">
      <v-btn
        v-if="orderStepper != 2 "
        icon
        @click="backPrevious"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title v-if="deleteDialog != true">
        {{ titles[orderStepper] }}
      </v-toolbar-title>

      <v-btn
        v-if="orderStepper == 1 "
        style="margin-left: auto;"
        icon
        @click="submitSearch"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>
          mdi-arrow-right-top-bold
        </v-icon>
      </v-btn>
    </v-toolbar>

    <div v-if="orderStepper == 1 && deleteDialog != true ">
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="fromMenu"
                  v-model="fromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    type="date"
                    no-title
                  >
                  </v-date-picker>
                </v-menu>

                <v-menu
                  ref="toMenu"
                  v-model="toMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    type="date"
                    no-title
                  >
                  </v-date-picker>
                </v-menu>

                <v-text-field
                  v-model="searchKeyWord"
                  label="Name or Order No"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else-if="orderStepper == 2 && deleteDialog != true">
      <swipe-list
        ref="swipeList"
        class="card"
        :disabled="!enabled"
        :items="content.items"
        item-key="id"
        :revealed.sync="revealed"
        :item-disabled="({ disabled }) => disabled"
        @closed="setLastEvent('closed', $event)"
        @leftRevealed="setLastEvent('leftRevealed', $event)"
        @rightRevealed="setLastEvent('rightRevealed', $event)"
      >
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
          <!-- item is the corresponding object from the array -->
          <!-- index is clearly the index -->
          <!-- revealLeft is method which toggles the left side -->
          <!-- revealRight is method which toggles the right side -->
          <!-- close is method which closes an opened side -->
          <div
            ref="content"
            class="card-content"
            @click="itemClick(item)"
          >
            <v-list-item>
              <v-list-item-avatar>
                <!-- class="grey lighten-1 white--text" -->
                <v-img
                  :src="avatarGetLink(item.userRecord.avatar)"
                  shape="circle"
                />
                <!-- <v-icon

      v-text="`mdi-account`"
    ></v-icon> -->
              </v-list-item-avatar>
              <v-list-item-content>
                <!-- class="font-weight-bolder" -->

                <v-list-item-subtitle
                  style="font-weight: 100"
                  v-text="item.orderNo"
                ></v-list-item-subtitle>
                <v-list-item-title
                  class="font-weight-black"
                  v-text="item.userRecord.fullName"
                ></v-list-item-title>
                <v-list-item-title
                  v-text="item.course.courseName"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="`Total : $${item.totalAmount}`"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="`Session : ${item.sessionTotal}`"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="`Expriy Date : ${formatDate(item.expiryDate)}`"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>

        <!-- <template v-slot:right="{ item }">
      <div class="swipeout-action blue"   @click="edit(item)">

        <v-icon large color="white">mdi-format-list-bulleted-square</v-icon>
      </div>
      <div class="swipeout-action red"   @click="submitDelete(item)">

        <v-icon large color="white">mdi-trash-can</v-icon>

      </div>
    </template> -->
        <template v-slot:empty>
          <div>
            <!-- change mockSwipeList to an empty array to see this slot in action  -->
            list is empty ( filtered or just empty )
          </div>
        </template>
      </swipe-list>
    </div>
    <div v-else-if="orderStepper == 3 && deleteDialog != true">
      <OrderPrintView
        v-show="false"
        ref="orderPrintView"
        :order-id="reviewData.id"
      ></OrderPrintView>
      <!-- #Order Detail -->
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Center </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ tempCenterCode.code }}
                </v-card-text>

                <!-- <universal-input
            v-model="tempCenterCode"
            :config="inputCenterConfig"
          ></universal-input> -->
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Order No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.orderNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.userNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership Name </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.fullName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Gender </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.gender }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>HKID</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.hkid }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Telephone</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.mobileNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Email</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.email }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Promotion</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ promotionName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Course</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.course.courseName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Program</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.sessionTotal }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Total Amount</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.totalAmount }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Effective Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.effectiveDate ?
                    formatDate(reviewData.effectiveDate): ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Expiry Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.expiryDate ?
                    formatDate(reviewData.expiryDate) : ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="12">
                <v-btn
                  color="#3467eb"
                  left
                  plain
                  @click="submitConditionPage"
                >
                  <u>Terms & Condition</u>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="#3467eb"
                  left
                  plain
                  @click="handlePrint"
                >
                  <u>Print Order</u>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else-if="orderStepper == 4 && deleteDialog != true">
      <v-container class="card-container">
        <v-card
          class="scroll"
          style="width: 100%;"
        >
          <v-card-text>
            <RichEditor
              :current-data="termsConditionItemData"
              disable-button
            >
            </RichEditor>
          </v-card-text>
        </v-card>
      </v-container>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="deleteDialog"
        width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5"><b>Void Order {{ reviewData.orderNo }}</b></span>
          </v-card-title>
          <v-card-text>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="voidReason"
                label="Reason"
              ></v-text-field>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              text
              @click="deleteDialog = false"
            >
              Back
            </v-btn>
            <!-- color="green darken-1" -->
            <v-btn
              :loading="loading"
              color="dark"
              text
              @click="confirmSubmitDelete"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5 wrap"><b>Transfer order from {{ oldCenter }} to {{ newCenter }}?</b><br></span>

            <span class="wrap editH1Dialog">
              <br>
              All existing incomplete course booking would be cancel if invalid for {{ newCenter }}
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              text
              @click="editDialog = false"
            >
              Back
            </v-btn>
            <!-- color="green darken-1" -->
            <v-btn
              :loading="loading"
              color="blue"
              text
              @click="confirmSubmitEdit"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-overlay
      :z-index="999"
      :value="progressLoading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref } from 'vue'
import * as moment from 'moment'
import { SwipeList, SwipeOut } from 'vue-swipe-actions'
import { getItem as getTermsConditionItem } from '@/api/termsCondition'
import { createItem, deleteItem, fetchList, getItem, updateItem, studentFetchList } from '@/api/salesOrder'
import { fetchList as centerFetchList } from '@/api/center'

// import css from '../../src/styles/vue-swipe-actions.css';

import { fetchList as pomotionFetchList } from '@/api/promotion'
import RichEditor from '@/components/RichEditor/RichEditor.vue'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import 'vue-swipe-actions/dist/vue-swipe-actions.css'

import OrderPrintView from '../OrderPrintView.vue'

export default {
  name: 'OrderHistory',
  components: {
    CRUDTable,
    SwipeOut,
    SwipeList,
    UniversalInput,
    RichEditor,
    OrderPrintView,
  },
  data() {
    return {
      enabled: true,
      page: 0,
      revealed: {},
      lastEventDescription: '',
      mockSwipeList: [
        [
          {
            id: 'a',
            title: 'Some title',
            description: 'some description',
            disabled: true,
          },
          {
            id: 'b',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'c',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
        ],
        [
          {
            id: 'd',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'e',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'f',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
        ],
      ],
      titles: {
        1: 'Order Search',
        2: 'Order List',
        3: 'Order Detail',
        4: 'Terms Conditions',
        5: 'Order Commission',
      },
      orderStepper: 2,
      fromDate: moment(Date.now()).format('YYYY-MM-DD'),
      fromMenu: false,
      toDate: moment(Date.now()).clone().add('days', 150).format('YYYY-MM-DD'),
      toMenu: false,
      searchKeyWord: '',
      progress: false,
      content: [],
      reviewData: [],
      testitems: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
      centerItems: [],
      tempCenterCode: '',
      inputCenterConfig:
{
  propName: 'tempCenterCode',

  // label: 'Code',
  // defaultValue: 5,
  type: {
    name: 'select',
    items: [],
    itemText: 'code',
    itemValue: 'id',
  },
},
      deleteDialog: false,
      voidReason: '',
      editDialog: false,
      oldCenter: '',
      newCenter: '',

      promotionName: '',
      termsConditionItemData: '',
    }
  },
  mounted() {
    // ideally should be in some global handler/store
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
    this.submitSearchWithoutChangeOrderStepper()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
  },

  // mounted(){
  //   // this.$set(this.inputCenteConfig.type, 'items', this.centerItems)

  // },
  methods: {

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    avatarGetLink(avatar) {
      if (avatar == undefined) {
        return ''
      }

      return process.env.VUE_APP_BASE_API + avatar
    },

    submitConditionPage() {
      this.progressLoading = true

      getTermsConditionItem(this.reviewData.termsID)
        .then(response => {
          this.termsConditionItemData = response.data.record.content
          this.orderStepper = 4
          this.progressLoading = false
          this.scrollToTop()
        })
        .catch(err => {
          this.progressLoading = false
        })
    },
    listDetail(item) {
      console.log('edit', item)
      this.reviewData = item
      this.orderStepper = 3
      this.scrollToTop()
      this.promotionName = ''

      // centerFetchList({ page: 0, limit: 0    })
      //   .then(response => {
      //     console.log('center  response', response)
      //     this.centerItems = response.data.items
      //     this.inputCenterConfig.type.items.push(...this.centerItems)

      //     this.tempCenterCode  = this.centerItems.find(object => object.id === this.reviewData.centerID);
      //    console.log('this.tempCenterCode',  this.tempCenterCode  )
      //   })
      //   .catch(err => {
      //     // loading = false
      //    })

      if (this.reviewData.promotionID != 0) {
        pomotionFetchList({ page: 0, limit: 0 })
          .then(response => {
            console.log('center  response', response)

            const tempPromotionCode = response.data.items

            const result = tempPromotionCode.find(object => object.id === this.reviewData.promotionID)

            this.promotionName = result.description
          })
          .catch(err => {
            // loading = false
          })
      }
    },
    remove(item) {
      console.log('delete', item)
    },

    preSubmitEdit(item) {
      const oldObject = this.centerItems.find(object => object.id === this.reviewData.centerID)
      const newObject = this.centerItems.find(object => object.id === this.tempCenterCode)
      this.oldCenter = oldObject.code
      this.newCenter = newObject.code

      //  this.oldCenter
      //  this.oldCenter
      if (this.reviewData.centerID != this.tempCenterCode) {
        this.editDialog = true
      }
    },

    confirmSubmitEdit() {
      this.loading = true
      updateItem(this.reviewData)
        .then(response => {
          this.editDialog = false
          this.loading = false
          this.submitSearch()
        })
        .catch(err => {
          this.loading = false
          this.editDialog = false
        })
    },

    submitDelete(item) {
      this.deleteDialog = true

      this.reviewData = item
    },

    confirmSubmitDelete() {
      this.loading = true
      this.reviewData.voidReason = this.voidReason

      deleteItem(this.reviewData)
        .then(response => {
          this.deleteDialog = false
          this.voidReason = ''
          this.loading = false
          this.submitSearch()
        })
        .catch(err => {
          this.deleteDialog = false

          this.voidReason = ''
          this.loading = false
        })
    },

    setLastEvent(name, { item, index }) {
      this.lastEventDescription = {
        name,
        index,
        id: item.id,
      }

      if (name == 'rightRevealed') {
        console.log('this.lastEventDescription', this.lastEventDescription)
        this.closeOthers(index)
      }
    },

    closeOthers(index) {
      // console.log('closeOthers', index)
      // console.log('this.content', this.content)
      // console.log('this.$refs.swipeList.$refs.items', this.$refs.swipeList.$refs.items)
      const temp = this.$refs.swipeList.$refs.items[index]
      this.$refs.swipeList.$refs.items.forEach((i => {
        if (i != temp) { i.close() }
      }))
    },

    itemClick(e) {
      console.log(e, 'item click')

      this.reviewData = e
      this.listDetail(e)

      // this.orderStepper = 3
    },
    fbClick(e) {
      console.log(e, 'First Button Click')
    },
    sbClick(e) {
      console.log(e, 'Second Button Click')
    },

    // keyboard
    onKeyDown(e) {
      if (e.keyCode !== 16) return
      this.enabled = false
    },
    onKeyUp(e) {
      if (e.keyCode !== 16) return
      this.enabled = true
    },

    formatDate(date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = d.getFullYear()

      if (month.length < 2) { month = `0${month}` }
      if (day.length < 2) { day = `0${day}` }

      return [year, month, day].join('-')
    },
    submitSearch() {
      this.orderStepper = 2

      this.progressLoading = true

      //  loading.value = true
      studentFetchList()
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = false

          // loading = false
        })
    },
    submitSearchWithoutChangeOrderStepper() {
      this.progressLoading = true

      //  loading.value = true
      studentFetchList()
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = true

          // loading = false
        })
    },

    backPrevious() {
      if (this.orderStepper > 2) {
        this.orderStepper -= 1

        if (this.orderStepper == 2) { this.submitSearchWithoutChangeOrderStepper() }
      }
      if (this.orderStepper == 2) {
        this.content = []
      }
    },
    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },

    handlePrivacyPolicyPage() {
      getPrivacyPolicyItem()
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = true

          // loading = false
        })
    },
    handlePrint() {
      console.log('handlePrint', this.$refs.orderPrintView)
      this.$refs.orderPrintView.printOrder()
    },
  },
  setup() {
    const loading = ref(false)
    const progressLoading = ref(false)

    return {
      loading,
      progressLoading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<style>
/* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"); */

.centered {
position: fixed; /* or absolute */
top: 50%;
left: 50%;
}

.editH1Dialog{
color:red !important;
font-size:12px;
width:250px; /*Dont really required*/

text-align: center;
word-wrap: break-word;
}

.wrap{
width:250px; /*Dont really required*/
text-align: center;
word-wrap: break-word;
}

/* app specific styles */
.vcenter {
  display: flex;
  align-items: center;
  height: 56px;
}
.swipeout-action {
display: flex;
align-items: center;
padding: 0 3rem;
cursor: pointer;
left: 0;
}
/* https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/color/ */
.swipeout-action.blue {
  color: white;
  background-color: rgb(0, 122, 255);
}
.swipeout-action.blue:hover {
  background-color: darken(rgb(0, 122, 255), 5%);
}
.swipeout-action.purple {
  color: white;
  background-color: rgb(88, 86, 214);
}
.swipeout-action.purple:hover {
  background-color: darken(rgb(88, 86, 214), 5%);
}

.swipeout-action.red {
  color: white;
  background-color: rgb(255, 59, 48);
}
.swipeout-action.red:hover {
  background-color: darken(rgb(255, 59, 48), 5%);
}
.swipeout-action.green {
  color: white;
  background-color: rgb(76, 217, 100);
}
.swipeout-action.green:hover {
background-color: darken(rgb(76, 217, 100), 5%);
}

.swipeout-list-item {
flex: 1;
border-bottom: 1px solid lightgray;
}

.swipeout-list-item:last-of-type {
  border-bottom: none;
}

.card {
width: 100%;
background-color: white;
border-radius: 3px;
box-shadow: none;
border: 1px solid lightgray;
}
.card-content {
padding: 1rem;
}
.transition-right {
transform: translate3d(100%, 0 ,0) !important;
}
.transition-left {
transform: translate3d(-100%, 0 ,0) !important;
}

.toolbar {
display: flex;
align-items: center;
}

.toolbar .toolbar-section {
flex: 0 0 auto;
}

.toolbar .toolbar-section--center {
flex: 1000 1 0%;
}

</style>
